import NcfzTransfer from "@features/auth/component/userInfo/afterLogin/NcfzTransfer";
import NcfzToPlayncLogin from "@features/auth/component/userInfo/afterLogin/NcfzToPlayncLogin";
import PlayncWaiting from "@features/auth/component/userInfo/afterLogin/PlayncWaiting";
import AccountRegister from "@features/auth/component/userInfo/afterLogin/AccountRegister";
import PlayncUser from "@features/auth/component/userInfo/afterLogin/PlayncUser";
import LinkUtil from "@features/auth/component/userInfo/afterLogin/LinkUtil";
import { shallow } from "zustand/shallow";

import { useAuthStore } from "@core/stores/authStore";

export default function UserInfoAfterLogin() {
  const { auth, isWithdrawn } = useAuthStore(
    (state) => ({
      auth: state.auth,
      isWithdrawn: state.isWithdrawn, // 탈퇴 신청 여부
    }),
    shallow,
  );

  return (
    <div className="flex h-full w-full flex-col items-center justify-between">
      <div className="flex h-full w-full flex-col items-center justify-center">
        {auth === "NCFZ_USER_0" && <NcfzTransfer />}
        {auth === "NCFZ_USER_1" && <NcfzToPlayncLogin />}
        {auth === "PLAYNC_USER_0" && <AccountRegister />}
        {auth === "PLAYNC_USER_1" && <PlayncWaiting />}
        {auth === "PLAYNC_USER_2" && isWithdrawn && <PlayncWaiting isWithdrawn={true} />}
        {auth === "PLAYNC_USER_2" && !isWithdrawn && <PlayncUser />}
      </div>
      <LinkUtil />
    </div>
  );
}
